import React from 'react'
import styled from 'styled-components'
import { SpeedResultState } from 'src/Common/SpeedResultState'
import ExpectationBulletPoint from 'src/Result/ExpectationDetail/ExpectationBulletPoint'
import { localize } from 'src/lib/localize'

const Container = styled.div`
  flex: 1;
`

const title1 = localize('LABEL')('Smooth playback streaming at 4k quality')
const title2 = localize('LABEL')('Instant web browsing capabilities')
const title3 = localize('LABEL')('Reliable video calls')
const title4 = localize('LABEL')('Fast connected gaming experience')

const FastExpectationDetails = () => {
  return (
    <Container>
      <ExpectationBulletPoint
        resultState={SpeedResultState.FAST}
        title={title1}
      />
      <ExpectationBulletPoint
        resultState={SpeedResultState.FAST}
        title={title2}
      />
      <ExpectationBulletPoint
        resultState={SpeedResultState.FAST}
        title={title3}
      />
      <ExpectationBulletPoint
        resultState={SpeedResultState.FAST}
        title={title4}
      />
    </Container>
  )
}

export default FastExpectationDetails
